import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import store, { persistor } from "./store";
import AppRoutes from "./routes";
import "services/interceptors";

import "styles/App.less";
import "styles/index.scss";

function App() {
  //persistor.purge();
  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#b99022" } }}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <AppRoutes />
          </Router>
        </PersistGate>
      </Provider>
    </ConfigProvider>
  );
}

export default App;
